const isHiragana = (code) => {
  return 0x3040 <= code && code <= 0x309f; // 平仮名 (ぁ-ゟ)
};

const isKanji = (code) => {
  return (
    (0x4e00 <= code && code <= 0x9fcf) || // CJK統合漢字 (一-龥)
    (0x3400 <= code && code <= 0x4dbf) || // CJK統合漢字拡張A (㐂-䶮)
    (0xf900 <= code && code <= 0xfaff) || // CJK互換漢字 (豈-頻)
    code === 0x3005 ||
    code === 0x3007 ||
    code === 0x303b
  ); // CJKの記号及び句読点 (々〇〻)
};

const isFullKatakana = (code) => {
  return (
    (0x30a0 <= code && code <= 0x30ff) || // 片仮名 (゠-ヿ)
    (0x31f0 <= code && code <= 0x31ff)
  ); // 片仮名拡張 (ㇰ-ㇿ)
};

const isHalfAlphanumeric = (code) => {
  return (
    (0x0030 <= code && code <= 0x0039) || // ASCII数字 (0-9)
    (0x0041 <= code && code <= 0x005a) || // 大文字ラテン・アルファベット (A-Z)
    (0x0061 <= code && code <= 0x007a)
  ); // 小文字ラテン・アルファベット (a-z)
};

const isFullAlphanumeric = (code) => {
  return (
    (0xff10 <= code && code <= 0xff19) || // 全角ASCII (０-９)
    (0xff21 <= code && code <= 0xff3a) || // 全角ASCII(Ａ-Ｚ)
    (0xff41 <= code && code <= 0xff5a)
  ); // 全角ASCII (ａ-ｚ)
};

export {
  isHiragana,
  isKanji,
  isFullKatakana,
  isHalfAlphanumeric,
  isFullAlphanumeric,
};
